import React from "react";

import { Container } from "react-bootstrap";

import { localizePath } from "@/utils/i18nRoutes";
import { getCurrentLang } from "@/utils/Local";

import BannerComponent from "../components/Banner.component";
import DocumentComponent from "../components/Document.component";
import EventsComponent from "../components/Events.component";
import ScheduleComponent from "../components/Schedule.component";
import i18n from "../i18n";

const Events = (): React.JSX.Element => {
  const { t } = i18n;

  return (
    <React.Fragment>
      {/* Also served at the legacy /gallery alias, so the canonical is pinned
          to the events path rather than whatever URL was requested. */}
      <DocumentComponent
        canonicalPath={localizePath("/events", getCurrentLang())}
        title={t("Events")}
      />
      <BannerComponent description="" title={t("Events")} />
      <Container className="mb-5 galleryContainer">
        <EventsComponent />
      </Container>

      <ScheduleComponent />
    </React.Fragment>
  );
};

export default Events;
